import React from 'react';
var Logo = function (_a) {
    var size = _a.size, image = _a.image;
    var Image = image;
    return (React.createElement("div", { className: "logo logo--".concat(size) },
        React.createElement(Image, null)));
};
export default Logo;
